"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const material_1 = require("@mui/material");
const ListItemText_1 = tslib_1.__importDefault(require("@mui/material/ListItemText"));
const MneListItemText = (0, material_1.styled)(ListItemText_1.default, { shouldForwardProp: (prop) => prop !== "open" })(({ theme, open }) => ({
    paddingLeft: theme.spacing(2),
    opacity: open ? 1 : 0,
}));
exports.default = MneListItemText;
